import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import * as actions from "MODULES/users/actions";
import Form from "./Form";

export class VerifyEmail extends Component {
  state = {
    modalOpen: false
  };

  openModal = () => this.setState({ modalOpen: true });

  closeModal = () => this.setState({ modalOpen: false });

  requestVerification = () => {
    this.props.requestVerification({ active: false });
    this.closeModal();
  };

  render() {
    const { modalOpen } = this.state;
    const { user } = this.props;

    return (
      <div>
        {!user.verification_sent &&
          !user.email_verified && (
            <button
              className="btn btn-primary pull-right"
              style={{ marginLeft: "20px" }}
              onClick={this.requestVerification}
            >
              <i className="fa fa-fw fa-envelope" /> Validate Email
            </button>
          )}
        {user.verification_sent &&
          !user.email_verified && (
            <button
              className="btn btn-primary pull-right"
              style={{ marginLeft: "20px" }}
              onClick={this.openModal}
            >
              <i className="fa fa-fw fa-envelope" /> Verify Email
            </button>
          )}
        <Modal open={modalOpen} close={this.closeModal} dialogClass="modal-sm">
          <Header>
            <Close close={this.closeModal} />
            <h4 className="modal-title">Enter Token Sent To Email</h4>
          </Header>
          <Form close={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

VerifyEmail.propTypes = {
  requestVerification: PropTypes.func.isRequired
};

export default connect(state => ({ user: state.userDetail.toJS().user }), {
  requestVerification: actions.sendVerificationRequest
})(VerifyEmail);



// WEBPACK FOOTER //
// ./app/modules/users/components/VerifyEmail/VerifyEmail.jsx